module.exports = __webpack_public_path__ + "static/media/clipboard-prescription.455b210d.svg";